const EventTypeEnum = {
    FREE_DEMO: 1,
    BUY_LICENCE: 2,
    FREE_TRIAL: 3
}

module.exports = {
    EventTypeEnum
}